/**
 * Parses a comma-separated string of values, returning only unique alphanumeric items.
 * Used for processing the microsList input field.
 */
export function commaStringToUniqueAlphanumericList(value: string | undefined): string {
	if (!value) {
		return "";
	}

	const newList = Array.from(
		new Set(
			value
				.split(",")
				.map((s) => s.trim())
				.filter((s) => /^[a-zA-Z0-9]+$/.test(s)),
		),
	);

	return newList.join(",");
}
